import { useCallback, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export function useInstruction(stype) {
  const [data, setData] = useState(null);
  const [progress, setProgress] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const { data: res } = await api.get(`/service/${stype}`);
    setData(res.instruction?.data || {});
    setProgress(res.progress);
  }, [stype]);

  useEffect(() => { load(); }, [load]);

  const save = async (completed = false, silent = false) => {
    setSaving(true);
    try {
      const { data: res } = await api.post(`/service/${stype}/save`, { data, completed });
      setProgress(res.progress);
      if (!silent) toast.success(completed ? "Form completed" : "Draft saved");
      return true;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
      return false;
    } finally { setSaving(false); }
  };

  const submit = async () => {
    setSaving(true);
    try {
      await api.post(`/service/${stype}/submit`);
      toast.success("Instruction submitted. Confirmation emails sent.");
      await load();
      return true;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
      return false;
    } finally { setSaving(false); }
  };

  return { data, setData, progress, saving, save, submit, reload: load };
}
